import axios from "axios";
import type { ArticleFeedProps, ArticleProps, BracketCompetitionProps, BracketProps, CompanyEmbedProps, CompanyPlayerProps, CompanyPlayerStatProps, CompanyProps, CompetitionPayoutTypeProps, CompetitionPlayerProps, CompetitionProps, CompetitionRecordProps, CompetitionResultProps, CompetitionResultTypeProps, CompetitionTypeProps, EmbedPropertyProps, EmbedProps, EventProps, ExternalKeyProps, FlashMarketFeeProps, LeagueProps, PlayerReferralProps, PodcastProps, PollCampaignGoalProps, PollCampaignProps, PollProps, PromoProps, PublicPlayerProps, SquaresCompetitionProps } from "../../types";
import { APIOverrides } from "../../ApiOverrides";
import type { CompanyMemberProps } from "../../Authenticator/api/types";

let AUTH_SVC_API = '';
let SOCIAL_SVC_API = '';
let TP_SVC_API = '';
let EVENT_SVC_API = '';

export { PartnerPortalApi }

const PartnerPortalApi = {
    setEnvironment: () => {
        const endpoints = APIOverrides.getEndpoints();
        SOCIAL_SVC_API = endpoints['SOCIAL_SVC_API'] as string;
        AUTH_SVC_API = endpoints['AUTH_SVC_API'] as string;
        TP_SVC_API = endpoints['TP_SVC_API'] as string;
        EVENT_SVC_API = endpoints['EVENT_SVC_API'] as string;
    },
    CompanyApi : {
        getCompanyById: async (company_id: string): Promise<{ company: CompanyProps, company_members: CompanyMemberProps[] } | undefined> => {
            try {
                const resp = await axios.get(`${AUTH_SVC_API}/v1/companies/company/id/${company_id}`)
                return resp.data
            } catch (e) {
                return undefined
            }
        },
        getApiKeys:async(company_id:string):Promise<ExternalKeyProps[]> => {
            try {
                console.log(company_id)
                const resp = await axios.get(`${AUTH_SVC_API}/v1/keys/me/${company_id}`);
                return resp.data.external_keys
            } catch (e) {
                return []
            }
        },
        getCompanyPlayerStats: async(company_id:string):Promise<CompanyPlayerStatProps[]> => {
            try {
                const resp = await axios.get(`${AUTH_SVC_API}/v1/companies/stats/company/${company_id}`);
                return resp.data.company_stats
            } catch (e) {
                return []
            }
        },
        getCompanyPlayers: async(company_id:string, offset:number):Promise<CompanyPlayerProps[]> => {
            try {
                const resp = await axios.get(`${AUTH_SVC_API}/v1/companies/players/company/${company_id}?offset=${offset}`);
                return resp.data.company_players
            } catch (e) {
                return []
            }
        },
        getPodcastsByCompanyId:async(company_id:string, offset:number):Promise<PodcastProps[]> => {
            try {
                const resp = await axios.get(`${SOCIAL_SVC_API}/v1/podcasts/company/${company_id}?offset=${offset}`);
                return resp.data.podcasts
            } catch (e) {
                console.log(e);
                return []
            }
        },
        getArticlesByCompanyId: async(company_id:string, offset:number):Promise<ArticleProps[]> => {
            try {
                const resp = await axios.get(`${SOCIAL_SVC_API}/v1/articles/company/${company_id}?offset=${offset}`);
                console.log(resp.data)
                return resp.data.articles
            } catch (e) {
                return []
            }
        },
        getArticleFeedsByCompanyId: async(company_id:string):Promise<ArticleFeedProps[]> => {
            try {
                const resp = await axios.get(`${SOCIAL_SVC_API}/v1/articles/feeds/company/${company_id}`)
                console.log(resp.data)
                return resp.data.article_feeds
            } catch (e) {
                return []
            }
        },
        getReferralCodesByCompanyId: async(company_id:string):Promise<{ promos:PromoProps[], player_referrals:PlayerReferralProps[] }> => {
            try {
                const resp = await axios.get(`${AUTH_SVC_API}/v1/companies/referrals/${company_id}`);
                return resp.data
            } catch (e) {
                return { promos:[], player_referrals: [] }
            }
        },
        getReferralByCode: async(referral_code:string):Promise<{ player_referral?:PlayerReferralProps }> => {
            try {
                const resp = await axios.get(`${AUTH_SVC_API}/v1/promos/referral/code/${referral_code}`);
                return resp.data
            } catch (e) {
                console.log(e);
                return {}
            }
        },
        getReferralById: async(player_referral_id:string):Promise<PlayerReferralProps | undefined> => {
            try {
                const resp = await axios.get(`${AUTH_SVC_API}/v1/promos/referral/id/${player_referral_id}`);
                return resp.data.player_referral
            } catch (e) {
                console.log(e);
                return undefined
            }
        },
        getPromos: async():Promise<PromoProps[]> => {
            try {
                const resp = await axios.get(`${AUTH_SVC_API}/v1/promos/all`);
                return resp.data.promos
            } catch (e) {
                return []
            }
        },
        updateCodeOnReferral: async(player_referral:PlayerReferralProps):Promise<PlayerReferralProps | undefined> => {
            try {
                const resp = await axios.post(`${AUTH_SVC_API}/v1/promos/referral/promo/update`, { player_referral });
                return resp.data.player_referral
            } catch (e) {
                return undefined
            }
        },
        createCode: async(player_referral:PlayerReferralProps):Promise<PlayerReferralProps | undefined> => {
            try {
                const resp = await axios.post(`${AUTH_SVC_API}/v1/promos/referral/create`, { player_referral });
                return resp.data.player_referral
            } catch (e) {
                return undefined
            }
        },
        activateCode: async(player_referral_id:string):Promise<PlayerReferralProps | undefined> => {
            try {
                const resp = await axios.post(`${AUTH_SVC_API}/v1/promos/referral/activate`, { player_referral_id });
                return resp.data.player_referral
            } catch (e) {
                return undefined
            }
        },
        deactivateCode: async(player_referral_id:string):Promise<PlayerReferralProps | undefined> => {
            try {
                const resp = await axios.post(`${AUTH_SVC_API}/v1/promos/referral/deactivate`, { player_referral_id });
                return resp.data.player_referral
            } catch (e) {
                return undefined
            }
        },
        deleteCode: async(player_referral_id:string):Promise<PlayerReferralProps | undefined> => {
            try {
                const resp = await axios.post(`${AUTH_SVC_API}/v1/promos/referral/delete`, { player_referral_id });
                return resp.data.player_referral
            } catch (e) {
                return undefined
            }
        }
    },
    EngagementApi : {
        getActiveCompetitions: async(company_id:string):Promise<{competitions:CompetitionProps[], competition_players:CompetitionPlayerProps[], competition_records:CompetitionRecordProps[], competition_results:CompetitionResultProps[] }> => {
            try {
                const resp = await axios.get(`${TP_SVC_API}/v2/competitions/company/active/${company_id}`);
                return resp.data
            } catch (e) {
                return { competition_players: [], competition_records: [], competition_results: [], competitions: [] }
            }
        },
        getActiveSquaresCompetitions: async(company_id:string):Promise<SquaresCompetitionProps[]> => {
            try {
                const resp = await axios.get(`${TP_SVC_API}/v1/squares/company/active/${company_id}`);
                return resp.data.squares_competitions
            } catch (error) {
                return []
            }
        },
        getFlashCampaignById: async(poll_campaign_id:string):Promise<undefined | {poll_campaign:PollCampaignProps, flash_market_fees:FlashMarketFeeProps[], poll_campaign_goals:PollCampaignGoalProps[]}> => {
            try {
                const resp = await axios.get(`${AUTH_SVC_API}/v1/polls/campaigns/campaign/${poll_campaign_id}`);
                return resp.data
            } catch (e) {
                return undefined
            }
        },
        getFlashMarketsByCampaignId: async(poll_campaign_id:string):Promise<undefined | { polls:PollProps[] }> => {
            try {
                const resp = await axios.get(`${AUTH_SVC_API}/v1/polls/campaign/${poll_campaign_id}`);
                return resp.data
            } catch (e) {
                return undefined
            }
        },
        getActiveBracketCompetitions: async(company_id:string):Promise<BracketCompetitionProps[]> => {
            try {
                const resp = await axios.get(`${TP_SVC_API}/v1/brackets/company/active/${company_id}`);
                console.log(resp.data)
                return resp.data.bracket_competitions
            } catch (e) {
                console.log(e)
                return []
            }
        },
        getActiveFlashCampaigns: async(company_id:string):Promise<PollCampaignProps[]> => {
            try {
                const resp = await axios.get(`${AUTH_SVC_API}/v2/pm/company/active/${company_id}`);
                return resp.data.poll_campaigns
            } catch (e) {
                return []
            }
        }
    },
    EmbedApi: {
        getEmbeds: async():Promise<EmbedProps[]> => {
            try {
                const resp = await axios.get(`${AUTH_SVC_API}/v1/embeds/all`);
                return resp.data.embeds
            } catch (e) {
                return []
            }
        },
        getEmbedById: async(embed_id:string):Promise<{ embed:EmbedProps, embed_properties:EmbedPropertyProps[] }|undefined> => {
            try {
                const resp = await axios.get(`${AUTH_SVC_API}/v1/embeds/id/${embed_id}`);
                return resp.data
            } catch (e) {
                return undefined
            }
        },
        createEmbed: async(embed:EmbedProps):Promise<EmbedProps|undefined> => {
            try {
                const resp = await axios.post(`${AUTH_SVC_API}/v1/embeds/embed/create`, { embed });
                return resp.data.embed
            } catch (e) {
                return undefined
            }
        },
        updateEmbed: async(embed:EmbedProps):Promise<EmbedProps|undefined> => {
            try {
                const resp = await axios.post(`${AUTH_SVC_API}/v1/embeds/embed/update`, { embed });
                return resp.data.embed
            } catch (e) {
                return undefined
            }
        },
        activateEmbed: async(embed_id:string):Promise<EmbedProps|undefined> => {
            try {
                const resp = await axios.post(`${AUTH_SVC_API}/v1/embeds/embed/activate`, { embed_id });
                return resp.data.embed
            } catch (e) {
                return undefined
            }
        },
        deActivateEmbed: async(embed_id:string):Promise<EmbedProps|undefined> => {
            try {
                const resp = await axios.post(`${AUTH_SVC_API}/v1/embeds/embed/deactivate`, { embed_id });
                return resp.data.embed
            } catch (e) {
                return undefined
            }
        },
        archiveEmbed: async(embed_id:string):Promise<EmbedProps|undefined> => {
            try {
                const resp = await axios.post(`${AUTH_SVC_API}/v1/embeds/embed/archive`, { embed_id });
                return resp.data.embed
            } catch (e) {
                return undefined
            }
        },
        createEmbedProperty: async(embed_property:EmbedPropertyProps):Promise<EmbedPropertyProps| undefined> => {
            try {
                const resp = await axios.post(`${AUTH_SVC_API}/v1/embeds/property/create`, { embed_property });
                return resp.data.embed_property
            } catch (e) {
                return undefined
            }
        },
        updateEmbedProperty: async(embed_property:EmbedPropertyProps):Promise<EmbedPropertyProps| undefined> => {
            try {
                const resp = await axios.post(`${AUTH_SVC_API}/v1/embeds/property/update`, { embed_property });
                return resp.data.embed_property
            } catch (e) {
                return undefined
            }
        },
        archiveEmbedProperty: async(embed_property_id:string):Promise<EmbedPropertyProps| undefined> => {
            try {
                const resp = await axios.post(`${AUTH_SVC_API}/v1/embeds/property/archive`, { embed_property_id });
                return resp.data.embed_property
            } catch (e) {
                return undefined
            }
        }
    },
    CompanyEmbedApi: {
        getEmbedsByCompanyId: async(company_id:string, offset:number):Promise<{embed_properties:EmbedPropertyProps[], embeds:EmbedProps[], company_embeds:CompanyEmbedProps[]}> => {
            try {
                const resp = await axios.get(`${AUTH_SVC_API}/v1/embeds/company/id/${company_id}?offset=${offset}`);
                return resp.data
            } catch (e) {
                return { embed_properties: [], embeds:[], company_embeds:[] }
            }
        },
        getCompanyEmbedById: async(company_embed_id:string):Promise<undefined | { company_embed:CompanyEmbedProps, embed:EmbedProps, embed_properties:EmbedPropertyProps[] }> => {
            try {
                const resp = await axios.get(`${AUTH_SVC_API}/v1/embeds/company/embed/${company_embed_id}`);
                return resp.data
            } catch (e) {
                return undefined
            }
        },
        createCompanyEmbid: async(company_embed:CompanyEmbedProps):Promise<CompanyEmbedProps|undefined> => {
            try {
                const resp = await axios.post(`${AUTH_SVC_API}/v1/embeds/company/create`, { company_embed });
                return resp.data.company_embed
            } catch (e) {
                return undefined
            }
        },
        updateCompanyEmbed: async(company_embed:CompanyEmbedProps):Promise<CompanyEmbedProps|undefined> => {
            try {
                const resp = await axios.post(`${AUTH_SVC_API}/v1/embeds/company/update`, { company_embed });
                return resp.data.company_embed
            } catch (e) {
                return undefined
            }
        },
        addProperty: async(company_embed_id:string, embed_property_id:string, value:string):Promise<CompanyEmbedProps|undefined> => {
            try {
                const resp = await axios.post(`${AUTH_SVC_API}/v1/embeds/company/property/add`, { company_embed_id, embed_property_id, value });
                return resp.data.company_embed
            } catch (e) {
                return undefined
            }
        },
        removeProperty: async(company_embed_id:string, embed_property_id:string):Promise<CompanyEmbedProps|undefined> => {
            try {
                const resp = await axios.post(`${AUTH_SVC_API}/v1/embeds/company/property/remove`, { company_embed_id, embed_property_id });
                return resp.data.company_embed
            } catch (e) {
                return undefined
            }
        },
        activateCompanyEmbed:async(company_embed_id:string):Promise<CompanyEmbedProps | undefined> => {
            try {
                const resp = await axios.post(`${AUTH_SVC_API}/v1/embeds/company/activate`, { company_embed_id });
                return resp.data.company_embed
            } catch (e) {
                return undefined
            }
        },
        deActivateCompanyEmbed:async(company_embed_id:string):Promise<CompanyEmbedProps | undefined> => {
            try {
                const resp = await axios.post(`${AUTH_SVC_API}/v1/embeds/company/deactivate`, { company_embed_id });
                return resp.data.company_embed
            } catch (e) {
                return undefined
            }
        },
        archiveCompanyEmbed:async(company_embed_id:string):Promise<CompanyEmbedProps | undefined> => {
            try {
                const resp = await axios.post(`${AUTH_SVC_API}/v1/embeds/company/archive`, { company_embed_id });
                return resp.data.company_embed
            } catch (e) {
                return undefined
            }
        }
    },
    getPlayersByPlayerIds: async (player_ids: string[]): Promise<PublicPlayerProps[]> => {
        if (player_ids.length == 0) { return [] }
        try {
            const resp = await axios.post(`${AUTH_SVC_API}/v1/players/bulk/get`, { player_ids })
            return resp.data.players 
        } catch (e) {
            console.log(e);
            return []
        }
    },
    getLeagues: async():Promise<LeagueProps[]> => {
        try {
            const resp = await axios.get(`${EVENT_SVC_API}/v1/leagues?status=active`)
            return resp.data.leagues
        } catch (e) {
            return []
        }
    },
    getEventsByEventIds: async(event_ids:string[]):Promise<EventProps[]> => {
        try {
            if(event_ids.length == 0){ return [] }
            const resp = await axios.post(`${EVENT_SVC_API}/v1/events/bulk/get`, { attribute:'event_id', values: event_ids })
            return resp.data.events
        } catch (e) {
            return []
        }
    },
    getBracketsByIds: async(bracket_ids:string[]):Promise<BracketProps[]> => {
        try {
            if(bracket_ids.length == 0){ return [] }
            const resp = await axios.post(`${EVENT_SVC_API}/v1/brackets/bulk/get`, { bracket_ids })
            return resp.data.brackets
        } catch (e) {
            console.log(e)
            return []
        }
    },
    getCompetitionOptions: async():Promise<undefined | {competition_types:CompetitionTypeProps[], competition_result_types:CompetitionResultTypeProps[], competition_payout_types:CompetitionPayoutTypeProps[]}> => {
        try {
            const resp = await axios.get(`${TP_SVC_API}/v1/competitions/options`)
            return resp.data
        } catch (e) {
            console.log(e)
            return undefined
        }

    }
}

export const PartnerPortalHelpers = {
    prettyKey: (key?:string) => {
    try {
        if(!key){ return '' }
        let nested_key = key.split(':')
        let last_key = nested_key[nested_key.length - 1]
        if(!last_key){ return '' }
        let key_split = last_key.split('_')
        let pretty_key = ''
        key_split.map((k,i) => {
          let last_item = i == k.length -1 ? true : false
          let first_letter = k.charAt(0)
          first_letter = first_letter.toUpperCase()
          pretty_key += `${first_letter}${k.substring(1)}`
          if(!last_item){ pretty_key += ' ' }
        })
        return pretty_key   
    } catch (e) {
        console.log(e)
        return key
    }
    },
    CompanyHelpers: {
        generateNewReferral: ():PlayerReferralProps => {
            return {
                player_referral_id:'',
                referral_code: '',
                referrer_id: '',
                company_id: '',
                status: 'pending',
                promo_id: ''
            }
        }
    }
}